import { useWriteOffModal } from './WriteOffModal.hook';
import { InformationCircleOutlineIc } from '@dsch/dd-icons';
import { InfoIconButton } from './WriteOffModal.styled';
import { useTheme } from 'styled-components';

const WriteOffModalInfoIcon = () => {
  const { openModal } = useWriteOffModal();
  const theme = useTheme();

  return (
    <InfoIconButton
      onClick={openModal}
      aria-label={'Open write-off information modal'}
    >
      <InformationCircleOutlineIc
        width="20"
        height="20"
        color={theme.donedeal.colors.BLUE}
      />
    </InfoIconButton>
  );
};

export { WriteOffModalInfoIcon };
